import Header from "./Header";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import About from "./About";
import AboutMe from "./AboutMe";
import Psychotherapy from "./Psychotherapy";
import ThankYou from "./ThankYou";
import GetInTouch from "./GetInTouch";

import QuestionAnswers from "./QuestionAnswers";

function Main() {
  return (
    <>
      <Header />
      <About />
      <AboutMe />
      <Psychotherapy />
      <ThankYou />
      <GetInTouch />
      <QuestionAnswers />
    </>
  );
}

export default Main;
